import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { renderRecordColor } from 'utils';

interface UsersCountProps {
    makerRecords: number;
    checkerRecords: number;
    approverRecords: number;
    title?: string;
}

const UsersCount = (
    { makerRecords, checkerRecords, approverRecords, title = "User Counts" }: UsersCountProps
) => {
    return (
        <Flex gap="20px">
            <Text>
                {title}:
            </Text>
            <Text>
                Business Maker
                <Text as="span" color={renderRecordColor(makerRecords)} ml="5px">
                    {makerRecords}
                </Text>
            </Text>
            <Text>
                Business Checker
                <Text as="span" color={renderRecordColor(checkerRecords)} ml="5px">
                    {checkerRecords}
                </Text>
            </Text>
            <Text>
                Business Approver
                <Text as="span" color={renderRecordColor(approverRecords)} ml="5px">
                    {approverRecords}
                </Text>
            </Text>
        </Flex>
    );
};

export default UsersCount;